import Swiper from 'swiper';
import { Navigation, Thumbs, Zoom, Pagination } from 'swiper/modules';
import 'swiper/css';

export function initializeProductImageSlider() {
    const thumbImageSlider = new Swiper(".thumbImageSlider", {
        spaceBetween: 10,
        slidesPerView: 4,
        watchSlidesProgress: true,
    });

    new Swiper(".mainImageSlider", {
        modules: [Thumbs, Navigation, Pagination],
        slidesPerView: 1,
        thumbs: {
            swiper: thumbImageSlider,
        },
        navigation: {
            nextEl: ".thumbImageSlider__navigation-button-next",
            prevEl: ".thumbImageSlider__navigation-button-prev",
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
    });
}

export function initializeProductImageModalDesktopSlider() {
    const thumbImageSliderModalDesktop = new Swiper(".thumbImageSliderModalDesktop", {
        modules: [],
        spaceBetween: 10,
        slidesPerView: 3,
        watchSlidesProgress: true,
        direction: "vertical",
        mousewheel: true,
    });

    new Swiper(".mainImageSliderModalDesktop", {
        modules: [Thumbs, Navigation],
        spaceBetween: 10,
        thumbs: {
            swiper: thumbImageSliderModalDesktop,
        },
        navigation: {
            nextEl: ".thumbImageSliderModalDesktop__navigation-button-next",
            prevEl: ".thumbImageSliderModalDesktop__navigation-button-prev",
        },
    });
}

export function initializeProductImageModalMobileSlider() {
    const thumbImageSliderModalMobile = new Swiper(".thumbImageSliderModalMobile", {
        modules: [],
        spaceBetween: 10,
        slidesPerView: "auto",
        watchSlidesProgress: true
    });

    new Swiper(".mainImageSliderModalMobile", {
        modules: [Thumbs, Zoom],
        zoom: true,
        spaceBetween: 10,
        thumbs: {
            swiper: thumbImageSliderModalMobile,
        },
    });
    new Swiper(".mainImageSliderModalMobileSingle", {
        modules: [Zoom],
        zoom: true,
        spaceBetween: 10,
    });
}
